<template>
  <div class="transition-container">
    <Transition
      @enter="enter"
      @leave="leave"
      @after-enter="afterEnter"
      @after-leave="afterLeave"
    >
      <div v-if="show">
        <slot />
      </div>
    </Transition>
  </div>
</template>

<script setup>
const props = defineProps({
  timing: { type: String, default: '300ms' },
  show: { type: Boolean, default: false }
});

const emits = defineEmits(['after-transition']);

function enter(el, done) {
  el.style.maxHeight = '0';
  el.style.overflow = 'hidden';
  // this forces the browser to apply the previous style changes and recalculate layout
  // https://stackoverflow.com/a/60686560/8290054
  void el.offsetHeight;
  el.style.transition = `max-height ${props.timing} ease`;
  el.style.maxHeight = el.scrollHeight + 'px';

  const cleanup = e => {
    if (e.target === el && e.propertyName === 'max-height') {
      el.removeEventListener('transitionend', cleanup);
      done();
    }
  };

  el.addEventListener('transitionend', cleanup);
}

function afterEnter(el, done) {
  el.style.maxHeight = 'auto';
  el.style.overflow = '';
  el.style.transition = '';

  emits('after-transition');
}

function leave(el, done) {
  el.style.maxHeight = el.scrollHeight + 'px';
  el.style.overflow = 'hidden';

  // this forces the browser to apply the previous style changes and recalculate layout
  void el.offsetHeight;
  el.style.transition = `max-height ${props.timing} ease`;
  el.style.maxHeight = '0';

  const cleanup = e => {
    if (e.target === el && e.propertyName === 'max-height') {
      el.removeEventListener('transitionend', cleanup);
      done();
    }
  };
  el.addEventListener('transitionend', cleanup);
}

function afterLeave(el) {
  el.style.maxHeight = '';
  el.style.overflow = '';
  el.style.transition = '';

  emits('after-transition');
}
</script>

<style scoped>
.transition-container > div {
  display: flex;
  flex-direction: column;
  gap: var(--pad-space-sp-12);
}
</style>
